/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Tue Dec 18 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import uiRouter from 'angular-ui-router';
import curriculumSetuptemplate from './views/curriculumSetupView.html';
import curriculumSetupController from './controllers/curriculumSetupController';

import './curriculumSetup.scss';

import _ from "underscore"
var module = angular.module('CurriculumSetupModule', [
    uiRouter
    //import modules
]).controller('curriculumSetup', curriculumSetupController);





// WEBPACK FOOTER //
// ./src/app/utilities/curriculumSetup/curriculumSetupModule.js